import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { authenticate } from "./utilities/datalayer";

const Login = () => {

    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            email: '',
            password: ''
        },
        validationSchema: Yup.object({
            email: Yup
                .string()
                .email('Must be a valid email')
                .max(255)
                .required('Email is required'),
            password: Yup
                .string()
                .max(255)
                .required('Password is required')
        }),
        onSubmit: async (values) => {
            await authenticate(values.email, values.password).then((result) => {
                if (result) {
                    window.location.href = "/";
                } else {
                    alert('error')
                }
            });
        }
    });

    return (
        <>
            <Box component="main" sx={{ alignItems: 'center', display: 'flex', flexGrow: 1, minHeight: '100vh', backgroundBlendMode: 'multiply', backgroundImage: "url('./bg-login.jpg')", backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
                <Container maxWidth="sm">
                    <form onSubmit={formik.handleSubmit}>
                        <Box sx={{ backgroundColor: '#fff', p: 4 }}>
                            <Box sx={{ pb: 1, pt: 3 }}>
                                <Typography align="center" color="textSecondary" variant="h3">
                                    Del Forno Quality Control System
                                </Typography>
                            </Box>
                            <TextField
                                error={Boolean(formik.touched.email && formik.errors.email)}
                                fullWidth
                                helperText={formik.touched.email && formik.errors.email}
                                label="Email Address"
                                margin="normal"
                                name="email"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                type="email"
                                value={formik.values.email}
                                variant="outlined"
                            />
                            <TextField
                                error={Boolean(formik.touched.password && formik.errors.password)}
                                fullWidth
                                helperText={formik.touched.password && formik.errors.password}
                                label="Password"
                                margin="normal"
                                name="password"
                                onBlur={formik.handleBlur}
                                onChange={formik.handleChange}
                                type="password"
                                value={formik.values.password}
                                variant="outlined"
                            />
                            <Box sx={{ py: 2 }}>
                                <Button color="primary" disabled={formik.isSubmitting} fullWidth size="large" type="submit" variant="contained">
                                    Please Login
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </Container>
            </Box>
        </>
    );
};

export default Login;
